/// <amd-dependency path="jQueryUI/button"/>
/// <reference types="jquery" />

// tslint:disable: no-require-imports
import BuildResources = require("Build/Scripts/Resources/TFS.Resources.Build");
import BuildsTab = require("Build/Scripts/Explorer.BuildsTab");
import CompletedBuilds = require("Build/Scripts/Explorer.CompletedBuildsTab");
import SourceProviderManager = require("Build/Scripts/SourceProviderManager");

import CustomerIntelligenceConstants = require("Build.Common/Scripts/Common/CustomerIntelligence");
import BuildClientServices = require("Build.Common/Scripts/Api2.2/ClientServices");
import BuildCommonResources = require("Build.Common/Scripts/Resources/TFS.Resources.Build.Common");
import { BuildReason } from "Build.Common/Scripts/BuildReason";
import { BuildResult } from "Build.Common/Scripts/BuildResult";
import { BuildStatus } from "Build.Common/Scripts/BuildStatus";

import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import TFS_OM_Common = require("Presentation/Scripts/TFS/TFS.OM.Common");

import Build_Client = require("TFS/Build/RestClient");
import BuildContracts = require("TFS/Build/Contracts");

import Artifacts_Constants = require("VSS/Artifacts/Constants");
import Artifacts_Services = require("VSS/Artifacts/Services");
import Combos = require("VSS/Controls/Combos");
import Controls = require("VSS/Controls");
import Dialogs = require("VSS/Controls/Dialogs");
import Events_Action = require("VSS/Events/Action");
import Grids = require("VSS/Controls/Grids");
import Menus = require("VSS/Controls/Menus");
import Telemetry = require("VSS/Telemetry/Services");
import Utils_Core = require("VSS/Utils/Core");
import Utils_String = require("VSS/Utils/String");
import Utils_UI = require("VSS/Utils/UI");
import VSS = require("VSS/VSS");
import VSS_Resources_Platform = require("VSS/Resources/VSS.Resources.Platform");
import VSS_Service = require("VSS/Service");

import { ExternalLinkValidator } from "WorkItemTracking/Scripts/TFS.WorkItemTracking.LinkValidator";
import { RegisteredLinkTypeNames } from "WorkItemTracking/Scripts/RegisteredLinkTypeNames";
import { LinkForm } from "WorkItemTracking/Scripts/LinkForm";

import "VSS/LoaderPlugins/Css!Build/WorkItemIntegration.Linking";
import { CoreHttpClient7, getClient as getCoreClient } from "TFS/Core/RestClient";
import { ProjectState } from "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants";

const domElem = Utils_UI.domElem;
const tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();
const delegate = Utils_Core.delegate;

// The default limit on the GetProjects API is 100. Some orgs have more than 100 projects, so we need to raise the limit.
// 1000 is the largest number of projects we can fetch at once, which should be enough for basically all customers.
const maxProjectsToFetch = 1000;

export abstract class BuildLinkFormBase extends LinkForm {

    public $buildNumber: JQuery;
    private build: BuildContracts.Build;

    // tslint:disable-next-line: no-any
    constructor(options?: any) {
        super(options);
        this._validator = new ExternalLinkValidator(options);
    }

    public initialize() {
        super.initialize();
        this.build = null;

        let $containerTable: JQuery;
        let $buildNumberCell: JQuery;
        let $browseButtonCell: JQuery;
        let $browseButton: JQuery;

        super.initialize();

        $containerTable = $("<table class='vc-link-container' cellspacing=1 cellpadding=0><tr></tr></table>").appendTo(this._element);

        $buildNumberCell = $("<td class='changeset-container'></td>").appendTo($containerTable);
        $buildNumberCell.append(LinkForm.createTitleElement(BuildResources.WorkItemTitleBuildNumber, "cs-id"));

        this.$buildNumber = $("<input>")
            .attr("type", "text")
            .addClass("textbox")
            .addClass("changeset-id-cell")
            .attr("id", "cs-id")
            .appendTo($buildNumberCell);
        this._bind(this.$buildNumber, "keyup change", delegate(this, this._onBuildChange));

        $browseButtonCell = $("<td class='changeset-browse-container'></td>").appendTo($containerTable);
        // Creating button for changeset picker
        $browseButton = $("<button id='cs-find'>...</button>")
            .addClass("changeset-browse-button")
            .button()
            .appendTo($browseButtonCell);
        this._bind($browseButton, "click", delegate(this, this._onBrowseClick));
        this._bind($browseButton, "keydown", delegate(this, this._onKeyBoardOpen));

        // Adding comment field
        this._createComment();

        this.fireLinkFormValidationEvent(false);

    }

    public getBuildNumber() {
        return this.$buildNumber.val().trim();
    }

    public abstract getLinkTypeName();

    public getDuplicateMessage() {
        return BuildResources.LinksControlDuplicateBuild;
    }

    public _onValidId(buildId: number) {
        // No-op if this form has been disposed since the asynchronous calls were made.
        if (this.isDisposed()) {
            return;
        }

        // Constructing the external link uri
        const artifactUri = this._constructUri(buildId);

        // Checking to see whether the external link already exists or not
        if (!this._validator.isDuplicate(artifactUri)) {

            // Valid link. Firing this event will close the dialog
            this._fire("resultReady", [{
                linkType: this.getLinkTypeName(),
                comment: this.getComment(),
                links: [{ artifactUri: artifactUri }]
            }]);

            const executedEvent = new Telemetry.TelemetryEventData(
                CustomerIntelligenceConstants.BuildCommonCustomerIntelligenceArea.BUILDCOMMON,
                CustomerIntelligenceConstants.CustomerIntelligenceBuildLinking.OPEN_LINKED_BUILD,
                { buildLinkType: this.getLinkTypeName(), }
            );
            Telemetry.publishEvent(executedEvent);
            return false;
        }
        else {
            alert(this.getDuplicateMessage());
        }
    }

    public _constructUri(buildId: number): string {
        return Artifacts_Services.LinkingUtilities.encodeUri({
            tool: Artifacts_Constants.ToolNames.TeamBuild,
            type: Artifacts_Constants.ArtifactTypeNames.Build,
            id: "" + buildId
        });
    }

    private _onBuildChange() {
        const buildNumber = this.getBuildNumber();

        if (!buildNumber) {
            this.fireLinkFormValidationEvent(false);
        }
        else {
            this.fireLinkFormValidationEvent(true);
        }
    }

    public getLinkResult() {
        const buildNumber = this.getBuildNumber();

        if (!buildNumber.length) {
            // If no build number specified, display warning message
            alert(BuildResources.WorkItemNoBuildNumber);
        }
        // if specific build has been selected and the build number hasn't been changed afterwards, use that
        else if (this.build && Utils_String.defaultComparer(this.build.buildNumber, buildNumber) === 0) {
            // A specific build has been chosen in the build picker. Use its ID.
            this._onValidId(this.build.id);
        }
        else {
            // The build number has been entered manually; fetch its details and use its id.
            // Since a project has not been explicitly chosen, we have to assume this is a
            // build in the current project.
            const client = Build_Client.getClient();
            return client
                .getBuilds(tfsContext.navigation.project, undefined, undefined, buildNumber)
                .then((result: BuildContracts.Build[]) => {
                    if (result.length === 1) {
                        this._onValidId(result[0].id);
                    }
                    else {
                        alert(Utils_String.format(BuildResources.WorkItemBadBuildNumber, this.getBuildNumber()));
                    }
                });
        }
        // Returning undefined will cause dialog not to close. "resultReady" event will be fired later on by _onValidId
        // handler if the item is not a duplicate.
    }

    private _onKeyBoardOpen(keyboardEvent: JQueryKeyEventObject) {
        // Allow only ENTER key alone to open the dialog.
        if (keyboardEvent.keyCode === Utils_UI.KeyCode.ENTER) {
            this._launchBuildPicker();
        }
    }

    private _onBrowseClick(_mouseEvent: JQueryMouseEventObject) {
        this._launchBuildPicker();
    }

    private _launchBuildPicker() {
        const model = new BuildPickerDialogModel(tfsContext, (build: BuildContracts.Build) => {
            this.build = build;
            this.$buildNumber.val(build.buildNumber);
            this._onBuildChange();
        });
        const dialog = Dialogs.show(BuildPickerDialog, model);
    }
}

export class BuildLinkForm extends BuildLinkFormBase {
    public getLinkTypeName() {
        return RegisteredLinkTypeNames.Build;
    }
}

export class FoundInBuildLinkForm extends BuildLinkFormBase {
    public getLinkTypeName() {
        return RegisteredLinkTypeNames.FoundInBuild;
    }
}

export class IntegratedInBuildLinkForm extends BuildLinkFormBase {
    public getLinkTypeName() {
        return RegisteredLinkTypeNames.IntegratedInBuild;
    }
}

VSS.initClassPrototype(BuildLinkForm, {
    $buildNumber: null
});

VSS.initClassPrototype(FoundInBuildLinkForm, {
    $buildNumber: null
});

VSS.initClassPrototype(IntegratedInBuildLinkForm, {
    $buildNumber: null
});

export class BuildPickerDialogModel {
    public tfsContext: TFS_Host_TfsContext.TfsContext;
    public okCallback: (build: BuildContracts.Build) => void;
    public className: string;
    public projectDropdownEnabled: boolean;

    constructor(
        tfsCtx: TFS_Host_TfsContext.TfsContext,
        okCallback?: (build: BuildContracts.Build) => void,
        className?: string,
        projectDropdownEnabled?: boolean 
    ) {
        this.tfsContext = tfsCtx;
        this.okCallback = okCallback;
        this.className = className;
        this.projectDropdownEnabled = (projectDropdownEnabled === null || projectDropdownEnabled === undefined) ? true : projectDropdownEnabled;
    }
}

// show with Dialogs.show(BuildPickerDialog, model)
export class BuildPickerDialog extends Dialogs.ModalDialog {
    private _model: BuildPickerDialogModel;
    private _buildClient: BuildClientServices.BuildClientService;
    private _coreClient: CoreHttpClient7;

    private _$buildNumber: JQuery;
    private _$findButton: JQuery;
    private _$buildsGrid: JQuery;
    private _$loadingMessage: JQuery;
    private _$moreBuildsMessage: JQuery;

    private _projectsCombo: Combos.Combo;
    private _definitionCombo: Combos.Combo;
    private _resultCombo: Combos.Combo;
    private _fromCombo: Combos.ComboO<Combos.IDateTimeComboOptions>;
    private _toCombo: Combos.ComboO<Combos.IDateTimeComboOptions>;
    private _buildsGrid: CompletedBuildsGridLight;

    private _allDefinitions: BuildContracts.DefinitionReference[];
    private _filteredDefinitions: BuildContracts.DefinitionReference[];
    private _allProjectIds: string[];
    private _definitionNames: string[];
    private _maxBuildsToShow: number = 50;

    private static _AriaDescribedById = "WIT_FIND_BUILDS_DESCRIPTION_ID";

    constructor(model: BuildPickerDialogModel) {
        super(model);

        this._model = model;
    }

    public initialize() {
        super.initialize();
        this._buildClient = TFS_OM_Common.ProjectCollection
            .getConnection(this._model.tfsContext)
            .getService<BuildClientServices.BuildClientService>(BuildClientServices.BuildClientService);
        this._coreClient = getCoreClient();

        this._initializeDomElements();

        // jquery adds aria-describedby by default and assigns it to the dialog content the problem
        // with that in our scenario is, since we used label for's everywhere, it would just combine
        // all of that and place that as "description" so when the dialog opens in addition to
        // reading the dialog title, it would also ready out all elements in the dialog. In our
        // case, that's not what we want and it causes confusion to the user so instead, let's just
        // set our own text that describes the dialog a bit hence, setting the right
        // aria-description for the dialog this._element corresponds to ui-dialog-content, accessing
        // parent would give us ui-dialog for which jquery UI injects aria-describedby to be the ID
        // of the ui-dialog-content
        this._element.parent().attr("aria-describedby", BuildPickerDialog._AriaDescribedById);

        // Adding this because we are using this dialog in LWP.
        // This dialog needs to be opened from another dialog and should appear on top of that dialog.
        // But in LWP for dialog z-index for base is 1000000 and hence this find builds dialog appears in background
        // So to override the z-index adding className.
        this._element.parent().addClass(this._model.className);

        this._allDefinitions = [];
        this._filteredDefinitions = [];
        this._definitionNames = [];

        this._buildClient.beginGetDefinitions().then((value) => {
            this._allDefinitions = value;
            this._filterDefinitions();
        });

        this._coreClient.getProjects(ProjectState.WellFormed, maxProjectsToFetch).then(projectReferences => {
            const orderedProjectReferences = projectReferences.sort((a, b) => Utils_String.localeIgnoreCaseComparer(a.name, b.name));
            this._allProjectIds = orderedProjectReferences.map(ref => ref.id);
            this._projectsCombo.setSource(orderedProjectReferences.map(ref => ref.name));
            this._projectsCombo.setSelectedIndex(this._allProjectIds.indexOf(tfsContext.navigation.projectId));
        });

        // filter the definitions to show when the dropdown is opened
        this._definitionCombo.getDropButton().on("mousedown", () => this._filterDefinitions());
    }

    public getProject(): string {
        return this._allProjectIds[this._projectsCombo.getSelectedIndex()];
    }

    public getDefinitionName(): string {
        return this._definitionCombo.getText().trim();
    }

    public getBuildNumber(): string {
        return this._$buildNumber.val().trim();
    }

    public getResult(): BuildContracts.BuildResult {
        return this._getEnumFromResultDisplay(this._resultCombo.getText().trim());
    }

    public getCompletedFrom(): Date {
        return this._fromCombo.getBehavior<Combos.ComboDateBehavior>().getSelectedDate();
    }

    public getCompletedTo(): Date {
        return this._toCombo.getBehavior<Combos.ComboDateBehavior>().getSelectedDate();
    }

    public getTitle(): string {
        return BuildResources.WorkItemBuildPickerTitle;
    }

    // tslint:disable-next-line: no-any
    public initializeOptions(options?: any) {
        const initialOptions = {
            resizable: false,
            width: 740,
            buttons: {
                "ok": {
                    id: "ok",
                    text: VSS_Resources_Platform.ModalDialogOkButton,
                    click: delegate(this, this.onOkClick)
                },
                "cancel": {
                    id: "cancel",
                    text: VSS_Resources_Platform.ModalDialogCancelButton,
                    click: delegate(this, this.close),
                }
            }
        };
        super.initializeOptions($.extend(initialOptions, options));
    }

    public onOkClick() {
        if (!this._buildsGrid || this._buildsGrid.getSelectedRowIndex() < 0) {
            alert(BuildResources.WorkItemBuildPickerNoBuildSelected);
        }
        else {
            this.updateOkButton(false);
            this._model.okCallback(this.getDialogResult());
            this.close();
        }
    }

    public dispose() {
        super.dispose();
    }

    // returns build
    public getDialogResult(): BuildContracts.Build {
        return this._buildsGrid.getRowData(this._buildsGrid.getSelectedRowIndex());
    }

    private _onFindClick(e?: JQueryEventObject) {
        // use this client so we can pass buildNumber as a filter
        const client = VSS_Service.getClient(Build_Client.BuildHttpClient2_3);
        this._setLoadingRowMessage(BuildResources.Loading);
        // pass undefined if field not filled out
        let definitionId;
        const definitionName = this.getDefinitionName();
        if (definitionName) {
            const defs = this._allDefinitions.filter((def, index) => {
                return Utils_String.localeIgnoreCaseComparer(def.name, definitionName) === 0;
            });
            if (defs.length > 0) {
                definitionId = defs[0].id;
            }
        }

        return client
            .getBuilds(
                this.getProject(),
                [definitionId],
                undefined,
                this.getBuildNumber() || undefined,
                this.getCompletedFrom() || undefined,
                this.getCompletedTo() || undefined,
                undefined,
                undefined,
                undefined,
                this.getResult(),
                undefined,
                undefined,
                undefined,
                this._maxBuildsToShow
            )
            .then((result: BuildContracts.Build[]) => {
                if (!this._buildsGrid) {
                    this._initializeGrid();
                }

                this._buildsGrid._updateGridSource(result);
                if (result.length >= this._maxBuildsToShow) {
                    this._$moreBuildsMessage.show();
                }
                else {
                    this._$moreBuildsMessage.hide();
                }

                if (result.length <= 0) {
                    this._setLoadingRowMessage(BuildResources.BuildStatusTextNoBuilds);
                } else if (result.length >= this._maxBuildsToShow) {
                    this._setLoadingRowMessage(BuildResources.WorkItemMoreBuildsMessage);
                } else {
                    this._setLoadingRowMessage(Utils_String.format(BuildResources.BuildStatusTextBuildsFound, result.length));
                }
            });
    }

    private _initializeDomElements(): void {
        $("<p></p>").text(BuildResources.WITFindBuildsAriaDescription)
            .addClass("visually-hidden")
            .attr("id", BuildPickerDialog._AriaDescribedById)
            .appendTo(this._element);

        const $containerTable = $("<table class='vc-link-container build-wit-link-container' cellspacing=1 cellpadding=0></table>")
            .appendTo(this._element);

        $containerTable.append(this._createBuildContextRow());
        $containerTable.append(this._createDateRangeRow());
        $containerTable.append(this._createLoadingRow());
        $containerTable.append(this._createBuildsGridRow());
        $containerTable.append(this._createMoreBuildsMessageRow());

        this.updateOkButton(true);
    }

    private _createBuildContextRow(): JQuery {
        const controlId = this.getId();
        const $buildContextRow = $("<tr class='filter-row' valign='bottom' />");

        // project combobox
        const $projectSelectorCell = $("<td class='build-filter'></td>")
            .attr("colspan", 1)
            .css("width", "50%")
            .appendTo($buildContextRow);
        const projectSelectorId = "project-selector-" + this.getId();
        LinkForm.createTitleElement(BuildResources.WorkItemProjectTitle, projectSelectorId).appendTo($projectSelectorCell);
        this._projectsCombo = Controls.BaseControl.createIn(Combos.Combo, $projectSelectorCell, {
            allowEdit: false,
            source: [],
            id: projectSelectorId,
            enabled: this._model.projectDropdownEnabled,
            isFocusableWhenDisabled: true,
        }) as Combos.Combo;

        // build number textbox
        const $buildNumberCell = $("<td class='build-filter'></td>")
            .attr("colspan", 1)
            .css("padding-left", "10px")
            .appendTo($buildContextRow);
        const $buildNumberTitle = LinkForm.createTitleElement(BuildResources.WorkItemTitleBuildNumber, "build-number");
        $buildNumberCell.append($buildNumberTitle);
        this._$buildNumber = $("<input>")
            .attr("type", "text")
            .addClass("textbox")
            .addClass("build-number-cell")
            .attr("id", "build-number")
            .appendTo($buildNumberCell);

        // build definition combo
        const $buildDefinitionCell = $("<td class='build-filter'></td>")
            .css("padding-left", "10px")
            .attr("colspan", 2)
            .appendTo($buildContextRow);
        const $buildDefinitionTitle = LinkForm.createTitleElement(BuildResources.WorkItemDefinitionText, "definition" + controlId);
        $buildDefinitionCell.append($buildDefinitionTitle);
        this._createDefinitionSelector($buildDefinitionCell, controlId);

        return $buildContextRow;
    }

    private _createDateRangeRow(): JQuery {
        const controlId = this.getId();
        const $dateRangeRow = $("<tr class='filter-row' valign='bottom' />");

        // result combo
        const $resultCell = $("<td class='build-filter'></td>").css("width", "25%")
            .appendTo($dateRangeRow);
        const $resultTitle = LinkForm.createTitleElement(BuildResources.WorkItemResultText, "result" + controlId);
        $resultCell.append($resultTitle);
        this._createResultSelector($resultCell, controlId);

        // from date range combo
        const $fromDateCell = $(domElem("td"))
            .css("width", "25%")
            .css("padding-left", "10px")
            .appendTo($dateRangeRow);
        $(domElem("label"))
            .attr("for", "from" + controlId + "_txt")
            .text(BuildResources.WorkItemFromText)
            .appendTo($fromDateCell);
        const $rangeFrom = $(domElem("div", "from"))
            .appendTo($fromDateCell);
        this._fromCombo = <Combos.Combo>Controls.BaseControl.createIn(Combos.Combo, $rangeFrom, { cssClass: "from-combo", id: "from" + controlId });

        this._fromCombo._options.dateTimeFormat = "G";
        this._fromCombo.setType("date-time");
        this._fromCombo.setMode("drop");

        // to date range combo
        const $toDateCell = $(domElem("td"))
            .css("width", "25%")
            .css("padding-left", "10px")
            .appendTo($dateRangeRow);
        $(domElem("label"))
            .attr("for", "to" + controlId + "_txt")
            .text(BuildResources.WorkItemToText)
            .appendTo($toDateCell);
        const $rangeTo = $(domElem("div", "to"))
            .appendTo($toDateCell);
        this._toCombo = <Combos.Combo>Controls.BaseControl.createIn(Combos.Combo, $rangeTo, { cssClass: "to-combo", id: "to" + controlId });

        this._toCombo._options.dateTimeFormat = "G";
        // Set Initial time value of To combo to 11:59:59.999 PM
        this._toCombo._options.defaultTimeOfDay = (24 * 60 * 60 * 1000) - 1;
        this._toCombo.setType("date-time");
        this._toCombo.setMode("drop");

        // find button
        const $findButtonCell = $(domElem("td"))
            .css("width", "1%")
            .css("padding-left", "10px")
            .appendTo($dateRangeRow);
        this._$findButton = $(domElem("button", "find"))
            .text(BuildResources.WorkItemFindText)
            .appendTo($findButtonCell)
            .addClass("vss-PivotBar--button bolt-button enabled bolt-focus-treatment")
            .css("max-width", "340px");
        this._$findButton.click(delegate(this, this._onFindClick));

        return $dateRangeRow;
    }

    private _createBuildsGridRow(): JQuery {
        // grid
        const $buildsGridRow = $("<tr class='filter-row' valign='bottom' />");
        const $buildsGridCell = $(domElem("td"))
            .attr("colspan", 4)
            .appendTo($buildsGridRow);
        this._$buildsGrid = $("<div class='build-picker-completed-build-grid' valign='bottom'/>")
            .css("height", "200px")
            .css("padding-top", 10)
            .appendTo($buildsGridCell);
        return $buildsGridRow;
    }

    private _createMoreBuildsMessageRow(): JQuery {
        // more builds message
        const $moreBuildsMessageRow = $("<tr class='filter-row' valign='bottom'/>");
        const $moreBuildsMessageCell = $(domElem("td"))
            .attr("colspan", 4)
            .appendTo($moreBuildsMessageRow);
        this._$moreBuildsMessage = $("<label>" + BuildResources.WorkItemMoreBuildsMessage + "</label>")
            .appendTo($moreBuildsMessageCell); // to do : resources
        this._$moreBuildsMessage.hide();

        return $moreBuildsMessageRow;
    }

    private _createLoadingRow(): JQuery {
        // used for screen reader alerts
        const $messageRow = $("<tr class='filter-row' valign='top' aria-live='polite'/>");
        const $messageCell = $(domElem("td"))
            .attr("colspan", 4)
            .appendTo($messageRow);
        this._$loadingMessage = $("<label class='message-loading-row'></label>")
            .appendTo($messageCell);

        return $messageRow;
    }

    private _setLoadingRowMessage(message?: string) {
        this._$loadingMessage.attr("aria-label", message || "");
    }

    private _initializeGrid() {
        this._buildsGrid = new CompletedBuildsGridLight();
        this._buildsGrid.enhance(this._$buildsGrid);
        this._buildsGrid._updateSource([]);
    }

    private _createDefinitionSelector($container: JQuery, controlId: string) {
        const $definitionInput = $(domElem("input", "definition"))
            .attr("id", "definition" + controlId)
            .appendTo($container)
            .val("");

        this._definitionCombo = <Combos.Combo>Controls.Enhancement.enhance(Combos.Combo, $definitionInput, {
            cssClass: "definition-combo",
            allowEdit: true,
            source: []
        });

        $("<span class = \"icon icon-search\"/>").appendTo(this._definitionCombo.getElement().find("div.drop"));
        this._definitionCombo.getElement().find("div.drop.bowtie-chevron-down-light").removeClass("bowtie-chevron-down-light");
    }

    private _createResultSelector($container: JQuery, controlId: string) {
        const $resultInput = $(domElem("input", "result"))
            .attr("id", "result" + controlId)
            .appendTo($container)
            .val("");

        this._resultCombo = <Combos.Combo>Controls.Enhancement.enhance(Combos.Combo, $resultInput, {
            cssClass: "result-combo",
            allowEdit: false,
            source: [
                BuildResources.WorkItemResultAllText,
                BuildResult.getDisplayText(BuildContracts.BuildResult.Succeeded),
                BuildResult.getDisplayText(BuildContracts.BuildResult.PartiallySucceeded),
                BuildResult.getDisplayText(BuildContracts.BuildResult.Failed),
                BuildResult.getDisplayText(BuildContracts.BuildResult.Canceled)
            ]
        });

        this._resultCombo.setSelectedIndex(0);
    }

    private _getEnumFromResultDisplay(display: string): BuildContracts.BuildResult {
        switch (display) {
            case BuildCommonResources.BuildResultSucceeded:
                return BuildContracts.BuildResult.Succeeded;
            case BuildCommonResources.BuildResultPartiallySucceeded:
                return BuildContracts.BuildResult.PartiallySucceeded;
            case BuildCommonResources.BuildResultFailed:
                return BuildContracts.BuildResult.Failed;
            case BuildCommonResources.BuildResultCanceled:
                return BuildContracts.BuildResult.Canceled;
            default: // show all
                return BuildContracts.BuildResult.Succeeded +
                    BuildContracts.BuildResult.PartiallySucceeded +
                    BuildContracts.BuildResult.Failed +
                    BuildContracts.BuildResult.Canceled;
        }
    }

    private _filterDefinitions(): void {
        if (this._allDefinitions && this._allDefinitions.length > 0) {
            this._filteredDefinitions = [];
            this._definitionNames = [];

            const nameFilter = this.getDefinitionName().toLocaleLowerCase().trim();

            this._allDefinitions.forEach((def, index) => {
                if (Utils_String.localeIgnoreCaseComparer(nameFilter, Utils_String.empty) === 0 ||
                    def.name.toLocaleLowerCase().indexOf(nameFilter) >= 0) {
                    this._filteredDefinitions.push(def);
                    this._definitionNames.push(def.name);
                }
            });

            this._definitionCombo.setSource(this._definitionNames);
        }
    }
}

export class CompletedBuildsGridLight extends CompletedBuilds.CompletedBuildsGrid {

    // Make the typing for _dataSource more specific than the superclass, which uses any[]
    _dataSource: CompletedBuilds.CompletedBuildGridRow[];

    constructor(options?: Grids.IGridOptions) {
        super(options);
    }

    // tslint:disable-next-line: no-any
    initializeOptions(options?: any) {
        const initialOptions = {
            allowMultiSelect: false,
            openRowDetail: (index: number) => {
                this.viewBuildInNewTab(this.getRowData(index));
            },
        };
        super.initializeOptions($.extend(initialOptions, options));
    }

    _getInitialColumns(): Grids.IGridColumn[] {
        return [
            {
                index: "reasonText",
                width: BuildsTab.ICON_CELL_WIDTH,
                canSortBy: true,
                getHeaderCellContents: (column: Grids.IGridColumn): JQuery => {
                    return this._createGridIconCell(column, "header", "reason", BuildResources.BuildReasonText);
                },
                getCellContents: (rowInfo, dataIndex, expandedState, level, column, indentIndex, columnOrder): JQuery => {
                    const buildRow = this._dataSource[dataIndex];
                    return this._createGridIconCell2(column, buildRow.reasonStyles, buildRow.reasonText);
                }
            }, {
                index: "statusText",
                width: BuildsTab.ICON_CELL_WIDTH,
                canSortBy: true,
                getHeaderCellContents: (column: Grids.IGridColumn): JQuery => {
                    const cell = $("<span class='icon icon-tfs-build-status-header' />");
                    cell.append($("<div/>").text(BuildResources.BuildStatusText).addClass("title hidden"));
                    return cell;
                },
                getCellContents: (rowInfo, dataIndex, expandedState, level, column, indentIndex, columnOrder): JQuery => {
                    const buildRow = this._dataSource[dataIndex];
                    if (!buildRow.isMoreLink) {
                        return this._createGridIconCell(column, buildRow.statusName, "status", buildRow.statusText);
                    }
                }
            }, {
                index: "buildNumber",
                text: BuildResources.CompletedBuildNameColumn,
                width: 175,
                getCellContents: (rowInfo, dataIndex, expandedState, level, column, indentIndex, columnOrder): JQuery => {
                    const buildRow = this._dataSource[dataIndex];
                    if (!buildRow.isMoreLink) {
                        return this._drawCell(rowInfo, dataIndex, expandedState, level, column, indentIndex, columnOrder);
                    }
                    else {
                        return this._createGridCell(column)
                            .append($(domElem("a"))
                                .text(BuildResources.MoreBuildsLinkText)
                                .on("click", () => {
                                    this._options.getMoreBuilds();
                                }));
                    }
                }
            }, {
                index: "definitionText",
                text: BuildResources.CompletedBuildDefinitionColumn,
                width: 175
            }, {
                index: "sourceBranchText",
                text: BuildResources.CompletedBuildSourceBranchColumn,
                width: 120
            }, {
                index: "finishTime",
                text: BuildResources.CompletedBuildDateColumn,
                width: 120,
                comparer: (column, order, buildRow1: CompletedBuilds.CompletedBuildGridRow, buildRow2: CompletedBuilds.CompletedBuildGridRow): number => {
                    if (buildRow1.finishTime instanceof Date && buildRow2.finishTime instanceof Date) {
                        return buildRow1.finishTime.getTime() - buildRow2.finishTime.getTime();
                    }

                    return 0;
                },
                getCellContents: (rowInfo, dataIndex, expandedState, level, column, indentIndex, columnOrder): JQuery => {
                    const finishTime = this._dataSource[dataIndex][column.index];
                    if (finishTime instanceof Date) {
                        return this._createGridDateCell(column, finishTime);
                    }
                    else {
                        // There might be cases where the finish time of a completed build might be empty.
                        // Displaying empty cell in this case.
                        return this._createGridCell(column);
                    }
                }
            }];
    }

    _getContextMenuItems(args?: {item: CompletedBuilds.CompletedBuildGridRow}): Menus.IMenuItemSpec[] {
        const result: Menus.IMenuItemSpec[] = [];
        const build = args.item;

        if (build.isMoreLink) {
            return;
        }

        // open build in new tab
        result.push({
            rank: 15, id: "open-build", text: BuildResources.OpenInNewTab, icon: "icon-open",
            action: () => {
                this.viewBuildInNewTab(build);
            }
        });

        return result;
    }

    _updateGridSource(builds: BuildContracts.Build[]): void {
        const sourceProvider = new SourceProviderManager.SourceProviderManager();

        super._updateSource($.map(builds, (build: BuildContracts.Build) => {
            let statusName = "";
            let statusText = "";

            // Extract status name and text
            switch (build.status) {
                case BuildContracts.BuildStatus.Completed:
                    statusName = BuildResult.getTextClassName(build.result);
                    statusText = BuildResult.getDisplayText(build.result);
                    break;
                case BuildContracts.BuildStatus.InProgress:
                    statusName = "inprogress";
                    statusText = BuildStatus.getDisplayText(build.status, build.result);
                    break;
                default:
                    statusName = "queued";
                    statusText = BuildStatus.getDisplayText(build.status, build.result);
                    break;
            }

            return <CompletedBuilds.CompletedBuildGridRow>$.extend(build, {
                retain: build.keepForever,
                reasonStyles: BuildReason.getStyles(build.reason),
                reasonText: BuildReason.getName(build.reason, true),
                statusName: statusName,
                statusText: statusText,
                definitionText: build.definition ? build.definition.name : "",
                isMoreLink: !build.id,
                sourceBranchText: sourceProvider.getSourceBranch(build),
                getSourceVersionGridCell: () => { return sourceProvider.getSourceVersionGridCell(build); }
            });
        }));
    }

    public viewBuildInNewTab(build: BuildContracts.Build) {
        Events_Action.getService().performAction(Events_Action.CommonActions.ACTION_WINDOW_OPEN, {
            target: "_blank",
            url: build._links.web.href
        });
    }
}

// TFS plugin model requires this call for each tfs module.
VSS.tfsModuleLoaded("WorkItemIntegration.Linking", exports);
